import { Drawer, Theme, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsSidebarOpen, uiActions } from '@/store';

import { SidebarList } from './components';

export const AppSidebar = () => {
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  const isSidebarOpen = useSelector(selectIsSidebarOpen);

  const handleSidebarClose = () => {
    dispatch(uiActions.toggleSidebarDrawer());
  };

  const drawerPaperStyles = ({ dimensions }: Theme) => ({
    '& .MuiDrawer-paper': {
      border: 'none',
      bgcolor: 'sidebar.background',
      width: dimensions.sidebar.width + 'px',
      pt: 1,
    },
  });

  if (!isDesktop) {
    return (
      <Drawer
        variant="temporary"
        anchor="left"
        open={isSidebarOpen}
        disableScrollLock={true}
        onClose={handleSidebarClose}
        sx={drawerPaperStyles}>
        <SidebarList />
      </Drawer>
    );
  }

  return null;
};
